module.exports = __webpack_public_path__ + "img/heart.4f0a33dd.svg";